import styled, { css } from 'styled-components';

import { BaseStyle, ReactTableStyles, TabBar } from '@nhl/nhl-breakaway-ui';

import { WithHidden } from '~/core/styleTypes';
import { SIZING } from '~/views/components/pageWrapper/styles';

export const LOADING_DISPLAY_SIZE = 80;
export const RIGHT_RAIL_GAP = BaseStyle.GAP_SIZES.large;

export enum GameCenterComponentGridAreas {
    ad = 'ad',
    gameInfoReports = 'gameInfoReports',
    gamePreview = 'gamePreview',
    gameRecap = 'gameRecap',
    gameStats = 'gameStats',
    goalieComparison = 'goalieComparison',
    highlights = 'highlights',
    iceSheet = 'iceSheet',
    lastTenOrPlayoffsRecord = 'lastTenOrPlayoffsRecord',
    lineScore = 'lineScore',
    mainContent = 'mainContent',
    penalties = 'penalties',
    playByPlay = 'playByPlay',
    playersToWatch = 'playersToWatch',
    rightRail = 'rightRail',
    scoringSummary = 'scoringSummary',
    seasonSeries = 'seasonSeries',
    shotsOnGoal = 'shotsOnGoal',
    teamRoster = 'teamRoster',
    teamStats = 'teamStats',
    threeStars = 'threeStars',
}

export const GrayText = styled.div<WithHidden>`
    ${BaseStyle.Mixins.fontStyles.ui['14m']}
    display: ${({ $isHidden }) => ($isHidden ? 'none' : 'initial')};
    color: ${({ theme }) => theme.Text.secondary};
`;

export const LoadingContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 468px;
    max-width: 100%;
`;

/**
 * Used for displaying the different Game Center components in the appropriate section (Left | Right for desktop)
 */
export const SectionContainer = styled.div`
    display: grid;
    gap: ${RIGHT_RAIL_GAP}px;
    grid-template-columns: 100%;
    grid-template-rows: auto;
    margin-bottom: 24px;

    ${BaseStyle.Mixins.screenSizes.large} {
        grid-template-areas: '${GameCenterComponentGridAreas.mainContent} ${GameCenterComponentGridAreas.rightRail}';
        grid-template-columns: 2fr 1fr;
    }
`;

export const Section = styled.div`
    ${BaseStyle.Mixins.gaps.large}
    display: flex;
    flex-direction: column;
`;

export const StyledTabBar = styled(TabBar)`
    .tab-bar {
        justify-content: center;
        overflow-x: hidden;

        ${BaseStyle.Mixins.screenSizes.large} {
            justify-content: left;
        }
    }
`;

export const StatDivider = styled.div`
    background: ${({ theme }) => theme.Surface.secondary};
    height: 1px;
    width: 100%;
`;

export const ReactTableContainer = styled.div`
    border-collapse: collapse;
    width: 100%;

    ${ReactTableStyles.CommonTableStyling};
`;

export const SelectorContainer = styled.div`
    display: flex;
    width: 100%;
    max-width: 376px;
    justify-content: center;
    align-items: center;
    height: 32px;

    border-radius: 8px;
    border: 1px solid ${({ theme }) => theme.Surface.border};
    box-sizing: border-box;

    overflow: hidden;
`;

export const SelectorItem = styled.div<{ $isSelected: boolean }>`
    ${BaseStyle.Mixins.fontStyles.ui['14b']}
    cursor: pointer;
    padding: 9px;
    width: 50%;
    text-align: center;
    align-self: center;

    color: ${({ $isSelected, theme }) => ($isSelected ? theme.Surface.primary : theme.Text.primary)};
    background: ${({ $isSelected, theme }) => ($isSelected ? theme.Text.primary : theme.Surface.primary)};
`;

// this is a way to give <a> elements enough specificity to overcome color properties set in the root styles. set type="link" on the corresponding element
export const LinkRootStyleOverride = css`
    &[type='link'] {
        color: ${({ theme }) => theme.Text.OppositeSurface.primary};

        // i hate that i have to do this for the hover state too. this is so stupid
        &:hover {
            color: ${({ theme }) => theme.Text.OppositeSurface.primary};
        }
    }
`;

// Although we don't apply any specific styles this ensures all section headers are the same
export const SectionHeader = styled.h4``;

export const LinkedButton = styled.a`
    display: flex;
    justify-content: center;
    align-self: center;
    ${BaseStyle.Mixins.fontStyles.ui['14b']}
    background: ${({ theme }) => theme.Utility.cta};
    border-radius: 8px;
    padding: 15px 5px;
    text-align: center;
    width: 100%;

    ${BaseStyle.Mixins.screenSizes.medium} {
        width: 135px;
    }

    ${LinkRootStyleOverride}
`;

export const SeriesPickerWrapper = styled.div`
    margin-bottom: 24px;
    max-width: ${SIZING.maxWidth}px;
    width: 100%;
`;
